<script lang="ts">
	import { auth_state } from '$lib/features/auth/state/auth_state';
	import { seller_state } from '$lib/features/profile/states/seller_state';
	import { Loc } from '$lib/tools/locale.svelte';
	import { onMount } from 'svelte';

	let sign_in_message = $state('');
	let expand_auth_form = $state(false);
	let auth_call_in_progress = $state(false);
	let phone_number = $state<string>();
	let phone_number_input = $state<HTMLInputElement>();

	async function sign_in_submit_handler(e: any) {
		e.preventDefault();

		auth_call_in_progress = true;

		const { fn_status } = await auth_state.sign_in(e.target);
		if (fn_status) auth_call_in_progress = true;
		else auth_call_in_progress = false;
	}

	async function sign_out_handler(e: any) {
		e.preventDefault();
		await auth_state.sign_out();
	}

	onMount(() => {
		setTimeout(() => {
			expand_auth_form = true;
		}, 500);
	});
</script>

<div class="mx-4 m-auto flex flex-col items-center justify-center">
	<div
		class="shopfront-scallop flex w-full max-w-sm flex-col justify-center rounded-2xl border border-border bg-card px-6 py-14"
	>
		<img class="mx-auto w-1/2 basis-1/3" src="/logos/shaggaga-full.png" alt={Loc('app_brand')} />

		<div class="my-3 h-px w-full bg-border"></div>
		<div class="flex basis-2/3 flex-col justify-center">
			{#if !expand_auth_form || auth_call_in_progress}
				<div class="mx-auto my-3 flex w-full flex-col items-center gap-2.5" role="status">
					<div class="h-11 w-full animate-pulse rounded-lg bg-muted"></div>
					<div class="h-11 w-full animate-pulse rounded-lg bg-muted"></div>
				</div>
			{:else if auth_state.value}
				<!-- Sign out -->
				<div>
					<div class="text-center text-xl font-semibold text-card-foreground">
						{Loc('welcome')}
						{seller_state.value?.name}
					</div>
					<form class="my-auto mt-4" onsubmit={sign_out_handler} id="login_form">
						<button
							name="sign_in"
							type="submit"
							class="h-11 w-full rounded-lg bg-primary px-4 text-sm font-semibold text-primary-foreground transition-all duration-150 hover:bg-primary/90 active:scale-[0.98] focus-visible:ring-[3px] focus-visible:ring-ring/50"
						>
							{Loc('logout')}
						</button>
					</form>
				</div>
			{:else}
				<form class="my-auto mt-2" onsubmit={sign_in_submit_handler} id="login_form">
					<div>
						<label for="email" class="block text-sm text-card-foreground">{Loc('phone_number')}</label>
						<input
							type="tel"
							inputmode="numeric"
							name="email"
							bind:value={phone_number}
							bind:this={phone_number_input}
							autocomplete="username"
							required
							dir="ltr"
							placeholder={Loc('phone_number')}
							class="mt-2 block h-11 w-full rounded-lg border border-input bg-background px-4 text-base tabular-nums text-card-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:border-destructive"
							onkeypress={(e) => {
								const input_value = e.key;
								if (!input_value) return;

								const valid_phone_number_char = /^[0-9]$/;
								const selected_text_length =
									(phone_number_input!.selectionEnd ?? 0) - (phone_number_input!.selectionStart ?? 0);
								const newInputLength = phone_number_input!.value?.length - selected_text_length + 1;

								if (!valid_phone_number_char.test(input_value) || newInputLength > 10) {
									e.preventDefault();
								}
							}}
							onpaste={(e) => {
								const pasted_text = e.clipboardData?.getData('text');
								const pasted_length = pasted_text?.length;
								if (!pasted_length) return;
								const selected_text_length =
									(phone_number_input!.selectionEnd ?? 0) - (phone_number_input!.selectionStart ?? 0);
								if (pasted_length + (phone_number_input!.value?.length ?? 0) - selected_text_length > 10) {
									e.preventDefault();
								}
							}}
						/>
					</div>

					<div class="mt-4">
						<div class="flex items-center justify-between">
							<label for="password" class="block text-sm text-card-foreground">{Loc('password')}</label>
						</div>

						<input
							type="password"
							name="password"
							required
							autocomplete="current-password"
							dir="ltr"
							placeholder={Loc('password')}
							class="mt-2 block h-11 w-full rounded-lg border border-input bg-background px-4 text-base text-card-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:border-destructive"
						/>
					</div>
					{#if sign_in_message}
						<p class="mx-auto mt-3 text-center text-sm text-destructive" role="alert">{sign_in_message}</p>
					{/if}

					<div class="mt-6">
						<button
							type="submit"
							class="h-11 w-full rounded-lg bg-primary px-4 text-sm font-semibold text-primary-foreground transition-all duration-150 hover:bg-primary/90 active:scale-[0.98] focus-visible:ring-[3px] focus-visible:ring-ring/50"
						>
							{Loc('login')}
						</button>
					</div>
				</form>
			{/if}
		</div>
	</div>
</div>
